import React from 'react'
import CustomAlert from '../../../components/shared/CustomAlert'
import { observer } from 'mobx-react-lite'
import ContentHtml from '../../../components/content/ContentHtml/ContentHtml.component'
import UserProfileService from '../../../shared/services/UserProfile.service'
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBRow } from 'mdb-react-ui-kit'
import { useState } from 'react'
import { useEffect } from 'react'

import LoadingSpinner from '../../../components/shared/LoadingSpinner.component'

const PointsRedemtion = () => {
  const [enableRymax, setEnableRymax] = useState(false)
  const [loading, setLoading] = useState(true)

  const getPipLevel = async () => {
    const currentYear = new Date().getFullYear(),
      previousYear = currentYear - 1,
      canEnableRymax = await UserProfileService.hasMetRequirements([
        { year: currentYear, requirement: 'pip-commission-level' },
        { year: currentYear, requirement: 'pip-team-commission-level' },
        { year: previousYear, requirement: 'pip-commission-level' },
        { year: previousYear, requirement: 'pip-team-commission-level' },
      ])

    setEnableRymax(canEnableRymax)
    setLoading(false)
  }

  useEffect(() => {
    setLoading(true)
    const fullYear = new Date().getFullYear()
    if (fullYear < 2024) {
      setEnableRymax(true)
      setLoading(false)
    } else {
      getPipLevel()
    }
  }, [])

  return (
    <MDBCard id='PointsRedemptionComponent' className='card-cascade narrower points-component'>
      <MDBCardBody className='pip-points-redemption'>
        <MDBCardTitle>USABG BUCK$ Redemption</MDBCardTitle>
        <MDBRow>
          <MDBCol size='12'>
            <ContentHtml contentSlug='pip-points-redemption-usabg' />
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol size='12'>
            {!enableRymax && !loading ? (
              <CustomAlert color='danger'>
                You haven&apos;t accrued the points required to access this feature.
              </CustomAlert>
            ) : (
              <></>
            )}
          </MDBCol>
          <MDBCol size='12'>
            {loading ? (
              <LoadingSpinner />
            ) : (
              <>
                <div className={enableRymax ? '' : 'pip-locked'}>
                  <ContentHtml contentSlug='pip-points-redemption-rymax' />
                </div>
              </>
            )}
          </MDBCol>
        </MDBRow>
      </MDBCardBody>
    </MDBCard>
  )
}

export default observer(PointsRedemtion)
